import './App.css';
import { RemoteCtrlMain } from './components/RemoteCtrlMain';

const App = function () {
  return (
    <div>
      <RemoteCtrlMain />
    </div>
  );
};

export default App;
